<div class="page-layout carded fullwidth">
    <!-- TOP BACKGROUND -->
    <div class="top-bg accent"></div>
    <!-- / TOP BACKGROUND -->

    <!-- CENTER -->
    <div class="center">
        <!-- CONTENT HEADER -->
        <div
            class="header accent p-24"
            fxLayout="row"
            fxLayoutAlign="start center"
        >
            <h2 class="m-0">
                <span *ngIf="!editar_nombre" class="px-20">{{
                    debidaDiligencia?.beneficiarioPersonaJuridica
                        ?.nombreBeneficiario ||
                        debidaDiligencia?.beneficiarioPersonaFisica
                            ?.nombreCompleto
                }}</span>
                <input
                    placeholder="Nombre"
                    matInput
                    [(ngModel)]="nombre"
                    *ngIf="editar_nombre"
                />
                <mat-icon
                    *ngIf="editar_nombre"
                    aria-hidden="false"
                    aria-label="Editar estado"
                    (click)="updateName(nombre)"
                    >save</mat-icon
                >
                <mat-icon
                    *ngIf="
                        is_eval_creador && debidaDiligencia?.estado != 'CERRADO'
                    "
                    aria-hidden="false"
                    aria-label="Editar nombre"
                    (click)="editar_nombre = true"
                    >edit</mat-icon
                >
            </h2>
        </div>
        <!-- / CONTENT HEADER -->

        <!-- CONTENT CARD -->
        <div class="content-card">
            <!-- CONTENT TOOLBAR -->
            <div class="toolbar px-24 py-8">
                <div>
                    <!--   -->
                    <mat-horizontal-stepper
                        [linear]="true"
                        #stepper
                        [selectedIndex]="this.selectedStatus"
                        (selectionChange)="setIndex($event)"
                        (click)="changeStatus()"
                        style="max-height: 60px"
                    >
                        <mat-step
                            [editable]="isEditable"
                            [completed]="isThisStepDone0"
                            [state]="isStepDone0"
                        >
                            <form [formGroup]="preiniciadoFormGroup">
                                <ng-template matStepLabel>Iniciado</ng-template>
                                <input
                                    matInput
                                    placeholder="Last name, First name"
                                    required
                                    class="invisible example-full-width"
                                />
                            </form>
                        </mat-step>
                        <mat-step
                            [editable]="isEditable"
                            [completed]="isThisStepDone1"
                            [state]="isStepDone1"
                        >
                            <form [formGroup]="completadoFormGroup">
                                <ng-template matStepLabel
                                    >Completado</ng-template
                                >
                                <input
                                    matInput
                                    placeholder="Last name, First name"
                                    required
                                    class="invisible example-full-width"
                                />
                            </form>
                        </mat-step>
                        <!-- <mat-step
                            [editable]="isEditable"
                            [completed]="isThisStepDone2"
                            [state]="isStepDone2"
                        >
                            <form [formGroup]="cerradoFormGroup">
                                <ng-template matStepLabel>Cerrado</ng-template>
                                <input
                                    matInput
                                    placeholder="Last name, First name"
                                    required
                                    class="invisible example-full-width"
                                />
                            </form>
                        </mat-step> -->
                    </mat-horizontal-stepper>
                </div>
                <div fxFlex fxLayout="row" fxLayoutAlign="end center">
                    <button
                        mat-button
                        (click)="
                            shareLink(debidaDiligencia?.formulario, 0, false)
                        "
                        mat-flat-button
                        color="primary"
                        class="add-row"
                    >
                        <mat-icon aria-hidden="false" aria-label="statistics"
                            >link</mat-icon
                        >
                    </button>
                    <button
                        mat-button
                        (click)="print()"
                        mat-flat-button
                        color="primary"
                        class="add-row"
                    >
                        <mat-icon aria-hidden="false" aria-label="print"
                            >print</mat-icon
                        >
                    </button>
                    <button
                        mat-button
                        (click)="goBack()"
                        mat-flat-button
                        color="primary"
                        class="add-row"
                    >
                        <mat-icon aria-hidden="false" aria-label="Salir"
                            >exit_to_app</mat-icon
                        >
                        Salir
                    </button>
                </div>
            </div>
            <!-- / CONTENT TOOLBAR -->

            <!-- CONTENT -->
            <div class="content p-24" style="max-height: 200px !important">
                <div id="scan" class="p-24" fxLayout="row" xFlex="100">
                    <div
                        fxLayout="column"
                        fxFlex="100"
                        fxFlex.gt-sm="100"
                        fxFlex.gt-md="50"
                    >
                        <div
                            class="profile-box info-box general"
                            fxLayout="column"
                        >
                            <table class="summary">
                                <tr>
                                    <td class="label">Cliente</td>
                                    <td class="value">
                                        <span
                                            class="px-20"
                                            *ngIf="
                                                debidaDiligencia?.cliente !=
                                                null
                                            "
                                            >{{
                                                debidaDiligencia?.cliente
                                                    ?.nombre
                                            }}</span
                                        >
                                        <a
                                            *ngIf="
                                                is_eval_creador &&
                                                debidaDiligencia?.estado ==
                                                    'INICIADO'
                                            "
                                            (click)="openDialog()"
                                            >Editar</a
                                        >
                                        <!--<mat-icon  aria-hidden="false" aria-label="Editar estado" (click)="openDialog()" >edit</mat-icon>-->
                                    </td>
                                </tr>

                                <tr>
                                    <td class="label">
                                        Documento de identidad
                                    </td>
                                    <td class="value">
                                        <span
                                            class="px-20"
                                            *ngIf="
                                                debidaDiligencia?.cliente !=
                                                null
                                            "
                                            >{{
                                                debidaDiligencia?.cliente
                                                    ?.razonSocial?.tipo?.nombre
                                            }}
                                            /
                                            {{
                                                debidaDiligencia?.cliente
                                                    ?.razonSocial?.numero
                                            }}</span
                                        >
                                        <a
                                            *ngIf="
                                                is_eval_creador &&
                                                debidaDiligencia?.estado ==
                                                    'INICIADO'
                                            "
                                            (click)="openDialog()"
                                            >Editar</a
                                        >
                                        <!--<mat-icon  aria-hidden="false" aria-label="Editar estado" (click)="openDialog()" >edit</mat-icon>-->
                                    </td>
                                </tr>
                            </table>
                        </div>
                    </div>

                    <div
                        fxLayout="column"
                        fxFlex="100"
                        fxFlex.gt-sm="100"
                        fxFlex.gt-md="50"
                    >
                        <div
                            class="profile-box info-box general"
                            fxLayout="column"
                        >
                            <table class="summary">
                                <tr class="code">
                                    <td class="label">Beneficiario</td>
                                    <td class="value">
                                        <span
                                            *ngIf="!editar_responsable"
                                            class="px-20"
                                        >
                                            {{
                                                debidaDiligencia?.nombreBeneficiario
                                            }}
                                        </span>
                                        <!--
                                  <mat-form-field *ngIf="editar_responsable" fxFlex>
                                    <mat-label>Responsable</mat-label>
                                    <mat-select [(ngModel)]="debidaDiligencia.responsable" class="roleSelect" (selectionChange)="selectDueno($event)">

                                      <ng-container *ngFor="let usuario of debidaDiligencia?.nodoEstructuraJerarquica?.usuarios">
                                        <mat-option *ngIf="esEvaluadorGroup(usuario)" [value]="usuario">
                                          {{usuario.nombreCompleto}}
                                        </mat-option>
                                      </ng-container>
                                      
                                        <mat-option *ngFor="let usuario of debidaDiligencia.nodoEstructuraJerarquica.usuarios" *ngIf="esOwnersGroup(usuario)" [value]="usuario">
                                            {{usuario.nombreCompleto}}
                                        </mat-option>
                                        
                                    </mat-select>
                                  </mat-form-field>
                                  -->
                                        <a
                                            *ngIf="is_eval_creador"
                                            (click)="editar_responsable = true"
                                            >Editar</a
                                        >
                                        <!--<mat-icon *ngIf="(is_owner && debidaDiligencia?.estado=='INICIADO') || (is_eval_creador)" aria-hidden="false" aria-label="Editar estado" (click)="editar_dueno=true" >edit</mat-icon>-->
                                    </td>
                                </tr>

                                <tr>
                                    <td class="label">Fecha de vigencia</td>
                                    <td class="value">
                                        <span
                                            *ngIf="!editar_fecha_fin"
                                            class="px-20"
                                            >{{
                                                debidaDiligencia?.fechaVencimiento
                                                    | date : "dd/MM/yyyy"
                                            }}</span
                                        >
                                        <mat-form-field
                                            color="accent"
                                            *ngIf="editar_fecha_fin"
                                            fxFlex
                                        >
                                            <mat-label
                                                >Fecha de vigencia</mat-label
                                            >
                                            <input
                                                matInput
                                                [matDatepicker]="picker2"
                                                [min]="fechaInicio"
                                                [(ngModel)]="fechaFin"
                                                (dateChange)="
                                                    selectFechaFin($event)
                                                "
                                            />
                                            <mat-datepicker-toggle
                                                matSuffix
                                                [for]="picker2"
                                            ></mat-datepicker-toggle>
                                            <mat-datepicker
                                                #picker2
                                            ></mat-datepicker>
                                        </mat-form-field>
                                        <a
                                            *ngIf="
                                                is_eval_creador &&
                                                debidaDiligencia?.estado ==
                                                    'INICIADO'
                                            "
                                            (click)="editar_fecha_fin = true"
                                            >Editar</a
                                        >
                                        <!--<mat-icon *ngIf="(is_owner && debidaDiligencia?.estado=='INICIADO') || (is_eval_creador)" aria-hidden="false" aria-label="Editar estado" (click)="editar_fecha_fin=true" >edit</mat-icon>-->
                                    </td>
                                </tr>
                                <tr>
                                    <td class="label">Creado por</td>
                                    <td class="value">
                                        <span class="px-20">{{
                                            debidaDiligencia?.remitente
                                                ?.nombreCompleto
                                        }}</span>
                                    </td>
                                </tr>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
            <!-- / CONTENT -->

            <!-- TABS -->

            <div class="content">
                <!-- <sentencia-tree [dataSource]="this.debidaDiligencia?.marcoDeReferencia" 
                        [tablaDeEvaluacion]="debidaDiligencia?.tablaDeEvaluacion"
                        [debidaDiligenciaEstado]="debidaDiligencia?.estado"
                        [isResponsable]="is_responsable" 
                        ></sentencia-tree>  -->

                <mat-tab-group
                    *ngFor="
                        let dataSource of this.debidaDiligencia?.formulario
                            ?.sentencias
                    "
                >
                    <mat-tab label="{{ dataSource.nombre }}">
                        <div fxFlex fxLayout="column">
                            <div>
                                <sentencia-tree
                                    [dataSource]="dataSource"
                                    [debidaDiligenciaEstado]="
                                        debidaDiligencia.formulario?.estado
                                    "
                                    [isResponsable]="is_responsable"
                                    [printable]="false"
                                    (loadData)="updateData()"
                                ></sentencia-tree>
                            </div>
                        </div>
                    </mat-tab>
                </mat-tab-group>
            </div>
            <!-- TABS fin -->
        </div>
        <!-- / CONTENT CARD -->
    </div>
    <!-- / CENTER -->
</div>
